import React, {Component} from 'react';
import {FaCreditCard} from 'react-icons/fa';
import Get from './components/Get';
import Colors from './components/color';

const options = {
  title: 'Loading',
  message: 'Please Wait',
  isCancelable: true,
};

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transection: null,
      loading: false,
    };
  }

  componentDidMount() {
    this._wallet();
  }

  _wallet() {
    const token = localStorage.getItem('user');
    console.log(token);
    if (token) {
      this.setState({loading: true});
      Get.results().then(res => {
        this.setState({loading: false});
        console.log(res, 'result');
        if (!res.error) {
          const data = res.data.map((v, i) => {
            const value =
              v.bidding.length > 0
                ? v.bidding.map((val, index) => (
                    <div style={styles.row} key={index}>
                      <div style={{...styles.col_1, ...styles.right}}>
                        <span>{val.bidding_time}</span>
                      </div>
                      <div
                        style={{
                          ...styles.col_1,
                          ...styles.left,
                          textAlign: 'center',
                        }}>
                        <span>{val.amount}</span>
                      </div>
                      <div
                        style={{
                          ...styles.col_1,
                          ...styles.left,
                          textAlign: 'center',
                        }}>
                        <span>{val.fk_number_id}</span>
                      </div>
                    </div>
                  ))
                : null;

            return (
              <div style={styles.container} key={i}>
                <div
                  style={{
                    backgroundColor: '#ccc',
                    padding: 10,
                    display: 'flex',
                    borderBottom: '0.5px solid #ccc',
                  }}>
                  <div
                    style={{
                      ...styles.col_1,
                      backgroundColor: '#ccc',
                      ...styles.right,
                    }}>
                    <span>{v.start}</span>
                  </div>
                  <div
                    style={{
                      ...styles.col_1,
                      backgroundColor: '#ccc',
                      ...styles.left,
                      textAlign: 'right',
                    }}>
                    <span>{v.result ? v.result.fk_number_id : '--'}</span>
                  </div>
                </div>

                {v.bidding.length > 0 && (
                  <div
                    style={{
                      backgroundColor: 'white',
                      padding: 2,
                      display: 'flex',
                      borderBottom: '0.5px solid #ccc',
                    }}>
                    <div style={{...styles.col_1, ...styles.right}}>
                      <span>Date</span>
                    </div>
                    <div
                      style={{
                        ...styles.col_1,
                        ...styles.left,
                        textAlign: 'center',
                      }}>
                      <span>&#8377;</span>
                    </div>
                    <div
                      style={{
                        ...styles.col_1,
                        ...styles.left,
                        textAlign: 'center',
                      }}>
                      <span>No</span>
                    </div>
                  </div>
                )}

                {value}
              </div>
            );
          });
          this.setState({transection: data});
        } else {
          this.setState({
            transection: (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '80vh',
                }}>
                <span>{res.errorMsg}</span>
              </div>
            ),
          });
        }
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.loading && (
          <div style={{textAlign: 'center', margin: 20}}>{options.message}</div>
        )}
        <div>{this.state.transection}</div>
      </div>
    );
  }
}

const styles = {
  container: {
    margin: 10,
    marginBottom: 2,
    backgroundColor: '#F5FCFF',
  },
  row: {
    backgroundColor: 'white',
    padding: 10,
    display: 'flex',
    borderBottom: '0.5px solid #ccc',
  },
  col_1: {
    flex: 2,
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: 'white',
  },
  right: {
    borderRight: '0.5px solid #ccc',
  },
  left: {
    borderLeft: '0.5px solid #ccc',
  },
};
